export default __webpack_public_path__ + "static/media/iconlock.77b58cd1.png";